import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import './AddRemarks.css';
import TauriImage from '../../../TauriImage/TauriImage';
import TauriLoader2 from '../../../TauriLoader2/TauriLoader2';

const AddRemarks = ({ show, onHide, onRemarks, loading }) => {
    const [sessionRemarks, setSessionRemarks] = useState('');

    const handleUpdate = () => {
        if (onRemarks) {
            onRemarks(sessionRemarks); // Pass remarks to parent
        }
    };

    useEffect(() => {
        setSessionRemarks('');
    }, [show])

    return (
        <Modal className='finish-session-remarks-modal'
            show={show}
            onHide={() => onHide(null)} size="lg"
            backdrop={"static"}
            keyboard={false}
            centered>
            <Modal.Header>Finish Session</Modal.Header>
            <Modal.Body className="modal-body-flex">
                <div className="textarea-wrapper">
                    <textarea
                        className="form-control textarea-expand"
                        value={sessionRemarks}
                        onChange={(e) => setSessionRemarks(e.target.value)}
                        placeholder="Type to input your Remarks"
                    />
                </div>
            </Modal.Body>

            <Modal.Footer className="justify-content-between">
                <Button className="btn-history" onClick={handleUpdate}>
                    <TauriImage localImage={"/Images/notes.svg"} className={"history"} alt='icon' color={"#000"} />
                    <div>History</div>
                </Button>
                <Button className="btn-finish-session" onClick={handleUpdate}>
                    {loading && (
                        <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#FFF" />
                    )}
                    <span>Update</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AddRemarks;
